import { Icon as LegacyIcon } from "@ant-design/compatible";
import { Menu } from "antd";
import { get } from "lodash";
import { Link } from "react-router-dom";

export const routes = {
  HomeEdit: {
    icon: "home",
    title: "首頁輪播設定",
    path: "/net-zero/home",
    showBreadcrumb: true,
    key: "HomeEdit"
  },
  ParamEdit: {
    icon: "setting",
    title: "首頁參數設定",
    path: "/net-zero/param",
    showBreadcrumb: true,
    key: "ParamEdit"
  },
  ParamMessageEdit: {
    icon: "",
    title: "訊息輪播設定",
    path: "/net-zero/message/:id",
    showBreadcrumb: true,
    key: "ParamMessageEdit"
  },
  ParamNumberEdit: {
    icon: "",
    title: "$[action]參數設定",
    path: "/net-zero/number/:id",
    showBreadcrumb: true,
    key: "ParamNumberEdit"
  },
  ImageEdit: {
    icon: "",
    title: "$[action]圖片",
    path: "/net-zero/image/:id",
    showBreadcrumb: true,
    key: "ImageEdit"
  },
  ImageList: {
    icon: "picture",
    title: "圖片列表",
    path: "/net-zero/images",
    showBreadcrumb: true,
    key: "ImageList"
  },
  FileEdit: {
    icon: "",
    title: "$[action]檔案",
    path: "/net-zero/file/:id",
    showBreadcrumb: true,
    key: "FileEdit"
  },
  FileList: {
    icon: "file",
    title: "檔案列表",
    path: "/net-zero/files",
    showBreadcrumb: true,
    key: "FileList"
  },
  NationEdit: {
    icon: "",
    title: "$[action]國際簡訊",
    path: "/net-zero/nation/:id",
    showBreadcrumb: true,
    key: "NationEdit"
  },
  NationList: {
    icon: "global",
    title: "國際簡訊",
    path: "/net-zero/nations",
    showBreadcrumb: true,
    key: "NationList"
  },
  ColumnEdit: {
    icon: "",
    title: "$[action]智庫觀點專欄",
    path: "/net-zero/column/:id",
    showBreadcrumb: true,
    key: "ColumnEdit"
  },
  ColumnList: {
    icon: "read",
    title: "智庫觀點專欄",
    path: "/net-zero/columns",
    showBreadcrumb: true,
    key: "ColumnList"
  },
  ActivityList: {
    icon: "team",
    title: "活動列表",
    path: "/net-zero/activities",
    showBreadcrumb: true,
    key: "ActivityList"
  },
  ActivityEdit: {
    icon: "team",
    title: "$[action]活動列表",
    path: "/net-zero/activity/:id",
    showBreadcrumb: true,
    key: "ActivityEdit"
  },
  VideoList: {
    icon: "youtube",
    title: "影片列表",
    path: "/net-zero/videos",
    showBreadcrumb: true,
    key: "VideoList"
  },
  VideoEdit: {
    icon: "",
    title: "$[action]影片",
    path: "/net-zero/video/:id",
    showBreadcrumb: true,
    key: "VideoEdit"
  },
  MagazineList: {
    icon: "book",
    title: "淨零刊物",
    path: "/net-zero/magazines",
    showBreadcrumb: true,
    key: "MagazineList"
  },
  MagazineEdit: {
    icon: "",
    title: "$[action]刊物",
    path: "/net-zero/magazine/:id",
    showBreadcrumb: true,
    key: "MagazineEdit"
  },
  FaqList: {
    icon: "question-circle",
    title: "常見問題",
    path: "/net-zero/faqs",
    showBreadcrumb: true,
    key: "FaqList"
  },
  FaqEdit: {
    icon: "",
    title: "$[action]常見問題",
    path: "/net-zero/faq/:id",
    showBreadcrumb: true,
    key: "FaqEdit"
  },
  ReportPage: {
    icon: "pie-chart",
    title: "官網報表",
    path: "/net-zero/report",
    showBreadcrumb: true,
    key: "ReportPage"
  },
  MeetingEdit: {
    icon: "",
    title: "$[action]會議記錄列表",
    path: "/net-zero/meeting/:id",
    showBreadcrumb: true,
    key: "MeetingEdit"
  },
  MeetingList: {
    icon: "profile",
    title: "會議記錄列表",
    path: "/net-zero/meeting",
    showBreadcrumb: true,
    key: "MeetingList"
  },
  EuroFileEdit: {
    icon: "",
    title: "$[action]歐盟/英國CBAM檔案下載",
    path: "/net-zero/eurofile/:id",
    showBreadcrumb: true,
    key: "EuroFileEdit"
  },
  EuroFileList: {
    icon: "file",
    title: "歐盟/英國CBAM檔案下載",
    path: "/net-zero/eurofile",
    showBreadcrumb: true,
    key: "EuroFileList"
  },
};

export const routeMap = {
  ImageList: {
    ImageEdit: undefined
  },
  HomeEdit: {},
  ParamEdit: {
    ParamNumberEdit: undefined,
    ParamMessageEdit: undefined
  },
  FileList: {
    FileEdit: undefined
  },
  NationList: {
    NationEdit: undefined
  },
  ColumnList: {
    ColumnEdit: undefined
  },
  ActivityList: {
    ActivityEdit: undefined
  },
  VideoList: {
    VideoEdit: undefined
  },
  MagazineList: {
    MagazineEdit: undefined
  },
  FaqList: {
    FaqEdit: undefined
  },
  ReportPage: undefined,
  MeetingList: {
    MeetingEdit: undefined
  },
  EuroFileList: {
    EuroFileEdit: undefined
  }
};

export const flatRouteMap = (() => {
  let res = {};
  function findIdxRoute(res, route, parent = []) {
    if (!route) return;
    Object.keys(route).forEach((x) => {
      if (!res[x]) res[x] = [...parent, x];
      if (route[x]) findIdxRoute(res, route[x], res[x]);
    });
  }

  findIdxRoute(res, routeMap);
  return res;
})();

/**
 *
 * @param {string} name
 * @param {string} object.key
 * @param {[string|object]} object.children
 */
export const menuByRouteName = (name = "") => {
  if (typeof name === "object") {
    const _key = Object.keys(name);
    if (_key.lenght === 0) return;
    const key = _key[0];
    const current = routes[key];
    if (!current) return;
    const childs = get(name, key, []);
    const { icon, title } = current;

    return (
      <Menu.SubMenu
        key={key}
        title={
          <span>
            <LegacyIcon type={icon} />
            <span>{title}</span>
          </span>
        }
      >
        {childs.map((r) => menuByRouteName(r))}
      </Menu.SubMenu>
    );
  }

  const current = routes[name];
  if (!current) return;
  else {
    const { path, icon, title } = current;
    return (
      <Menu.Item key={`${path}`}>
        <Link to={path}>
          <LegacyIcon type={icon} />
          <span>{title}</span>
        </Link>
      </Menu.Item>
    );
  }
};
